export default __webpack_public_path__ + "static/media/CW1.1cd44aa3.jpg";